import { Input } from "@ui/input";
import { Label } from "@ui/label";
import { ValidationError } from "@/components/ui/validation-error";
import type { NumberHeaderType } from "./types";
import { GridHeaderVisibilityFields } from "./visibility-fields";
export function NumberHeaderFields({
    header,
    updateHeader,
    headerError,
}: NumberHeaderType) {
    return (
        <GridHeaderVisibilityFields header={header} updateHeader={updateHeader}>
            <div>
                <Label>Placeholder</Label>
                <Input
                    value={(header.placeholder as string) ?? ""}
                    placeholder="Placeholder"
                    onChange={(e) => updateHeader({ placeholder: e.target.value })}
                />
            </div>
            <div>
                <Label>Default Value</Label>
                <Input
                    type="number"
                    value={header.defaultValue}
                    placeholder="Default Value"
                    onChange={(e) => {
                        const rawValue = e.target.value;
                        updateHeader({
                            defaultValue: rawValue === "" ? undefined : Number(rawValue),
                        });
                    }}
                />
            </div>
            {headerError && <ValidationError>{headerError}</ValidationError>}
        </GridHeaderVisibilityFields>
    );
}
